import { deleteSheetData } from "../../../Flux/Actions/PlacementActions";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { useCallback, useMemo, useRef } from "react";
import DeleteModal from "../../Modals/DeleteModal";
import TableHelper from "../../../Components/Table/TableHelper";

export default function useDelete({
	// this comment exists to prevent eslint from making this unreadable.
	auditLevelData,
	campaignMetaData,
	selectedRows,
	placementAPI,
	updateCounts,
	updateMetaData,
	config,
	dataTableApi,
	refresh,
	prismaAPIEnabled
}) {
	const deleteModal = useRef(null);

	const deleteData = useCallback(async () => {
		const postObject = TableHelper.formatPostObj({
			data: selectedRows,
			config,
			hierarchyLevel: "Placement",
			metaData: campaignMetaData,
			auditLevelID: auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "Placement")?.AuditLevelID
		});
		if (postObject.length > 0) {
			const placementIDsToDelete = [];
			postObject.forEach((placement) => {
				placementIDsToDelete.push(placement.PlacementData.PlacementID);
			});
			deleteSheetData(postObject, placementIDsToDelete);
		}
	}, [selectedRows, config, campaignMetaData, auditLevelData, updateCounts, updateMetaData]);

	const Trigger = useCallback(() => {
		return (
			<Tooltip key="action-delete" title="Delete Placements" position={TOOLTIP_POSITION.BOTTOM_START}>
				<Button
					// this comment exists to prevent eslint from making this unreadable.
					size={BUTTON_SIZE.SMALL}
					display={BUTTON_DISPLAY.ICON_BORDERED}
					icon="icon-trash"
					onClick={() => deleteModal.current.triggerOpenClose()}
					data-tracking-id-alt="open-delete-placements-modal"
				>
					Delete Placements
				</Button>
			</Tooltip>
		);
	}, []);

	const DisplayedComponent = useCallback(() => {
		return (
			<DeleteModal
				deleteModal={(ref) => {
					deleteModal.current = ref;
				}}
				deleteFunction={deleteData}
				data={selectedRows}
				placementAPI={placementAPI}
				prismaAPIEnabled={prismaAPIEnabled}
				type="Placement"
			/>
		);
	}, [deleteData, selectedRows, placementAPI, prismaAPIEnabled]);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
